import { Button, Table, TableColumnProps } from "antd";
import React, { ForwardedRef, useState } from "react";
import { EditableCell, EditableRow } from "./EditTable";
import "./TableInputAdd.scss";
import { AddBtnSVG, SubBtnSVG } from "assets";
import { SpinProps } from "antd/lib/spin";
import { TableRowSelection } from "antd/es/table/interface";
import dayjs from "dayjs";
interface TableInputAddProps {
  data: any;
  column: any;
  setData: any;
  pagination?: boolean | any;
  loading?: boolean | SpinProps;
  scroll?: any;
  onRow?: any;
  rest?: any;
  rowSelection?: any;
  disabled?: boolean;
  expandable?: any;
  defaultExpandAllRows?: any;
  expandedRowKeys?: any;
  style?: any;
  className?: any;
  rowClassName?: any;
}

const TableInputAdd = ({
  data,
  column,
  setData,
  disabled,
  ...rest
}: TableInputAddProps): JSX.Element => {
  const handleSave = (row, index) => {
    const newData = [...data];

    newData[index] = row;
    setData(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const columns = column.map((col) => {
    return {
      ...col,
      onCell: (record, index) => ({
        record,
        editable: col.editable,
        selected: col.selected,
        dataIndex: col.dataIndex,
        title: col.title,
        options: col.options,
        index: index,
        rules: col.rules,
        handleSave,
        type: col.type,
        disabled: disabled ?? col.disabled,
        value: col.value,
      }),
    };
  });

  return (
    <Table
      {...rest}
      components={components}
      bordered
      dataSource={data}
      columns={columns}
    />
  );
};

export default TableInputAdd;
